import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../models/hooks/adminStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = 'systemSurveyTemplate';

export interface ISystemSurveyTemplateQueryParams {
	id: string;
	enabled?: boolean;
}

/**
 * Admin: Get a system survey template by ID with industry mappings.
 * Returns the full template with per-industry status information.
 *
 * @param params - Query parameters including template ID
 * @returns React Query result with system survey template
 */
export function useSystemSurveyTemplateQuery(params: ISystemSurveyTemplateQueryParams) {
	const { id, enabled = true } = params;
	const userSession = useAdminUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.ISystemSurveyTemplate>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `admin/surveytemplate/${id}`,
					queryParams: {
						expand: 'options',
					},
				}),
				'GET'
			);
		},
		queryKey: [BASE_API_KEY, 'detail', id],
		enabled: enabled && !!id,
		staleTime: 10 * 60 * 1000, // 10 minutes
	});
}

export const invalidateSystemSurveyTemplateQuery = (id: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY, 'detail', id] });
};
